$component-class: 'banner-type-2';

.#{$component-class} {
  display: none;
  background-color: var(--background-color-secondary);
  padding: var(--radius-size-sm) 0;

  @include desktop {
    display: block;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--spacing-2xl);
  }

  .me-button {
    color: var(--action-color-primary);
    padding: 0;
  }

  &--dark {
    background-color: var(--background-color-tertiary);

    .me-button {
      color: var(--action-color-alternate);
    }
  }
}
